var map = {
	"./anders-consulting.png": "d6ab",
	"./boddenfilms.png": "be0f",
	"./daniela-mueller.png": "5fd3",
	"./eh.png": "8d25",
	"./fnf.jpg": "7466",
	"./fotof.png": "644d",
	"./hansfreitag.png": "366d",
	"./hostingwerft.png": "be65",
	"./jackle-heidi.png": "584a",
	"./seo-profi-berlin.jpg": "7e55",
	"./sparkasse-vorpommern.png": "9ee6",
	"./wfg.jpg": "56cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "15bd";